export default class Cach {
    private store = {} as any

    setCach(name: string, value: any) {
        this.store[name] = value
    }

    getCach(name: string) {
        return this.store[name] || null
    }
}